<script setup lang="ts">
export type TableCell = {
  textValue: string
  referenceId: string
}

type TableRow = {
  cells: TableCell[]
}

export type TableData = {
  rows: TableRow[]
}

export type TableProps = {
  table: TableData
  category?: string
  variant?: string
  underTableText?: string
}

const props = defineProps<TableProps>()

const currentComponent = computed(() => {
  switch (props.variant) {
    case 'stackedTable':
      return resolveComponent('StackedTable')
    case 'productDetailTable':
      return resolveComponent('ProductDetailTable')
    default:
      return resolveComponent('StackedTable')
  }
})
</script>

<template>
  <component :is="currentComponent" v-bind="$props" />
</template>

<style lang="postcss"></style>
